module.exports = __webpack_public_path__ + "assets/img/success.3c7af7b9.svg";